// extracted by mini-css-extract-plugin
export default {"man":"man_man__uGRb4","icon":"man_icon__so4YF","negative":"man_negative__suLXb"};